import keyWrapper from '~publish/helpers/keywrapper'

export const actionTypes = keyWrapper('PUBLISH_ANALYTICS', {
  INIT: 'INIT',
  TRACK_EVENT: 'TRACK_EVENT',
})

type AnalyticsPayload = Record<string, unknown>

type AnalyticsInitAction = {
  type: typeof actionTypes.INIT
  userId: string
  payload: AnalyticsPayload
}

type AnalyticsTrackEventAction = {
  type: typeof actionTypes.TRACK_EVENT
  eventName: string
  payload: AnalyticsPayload
}

export const actions = {
  init(userId: string, payload: AnalyticsPayload): AnalyticsInitAction {
    return {
      type: actionTypes.INIT,
      userId,
      payload,
    }
  },
  // TODO: Still used for tracking hashtag manager, instagram user tags, and possibly analyze report clicks - to be removed when hashtag manager is migrated
  /** @deprecated in favour of BufferTracker direct calls */
  trackEvent(
    eventName: string,
    payload: AnalyticsPayload,
  ): AnalyticsTrackEventAction {
    return {
      type: actionTypes.TRACK_EVENT,
      eventName,
      payload,
    }
  },
}

export default actions
